import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.equineStone,
  secondaryBgColor: colors.equineSnow,
  textColorDark: colors.equineIron,
  textColorLight: colors.equineSnow
};
export default imageSlider;